<script setup lang="ts">
	import { useI18n } from 'vue-i18n'
	import { _translations } from './_translations'

	const { t: _tr } = useI18n(_translations)
</script>

<template>
	<div class="modules-list">
		<p>{{ _tr('modules.listPlaceholder') }}</p>
	</div>
</template>
